import React from 'react';
import Divider from 'src/components/10-atoms/Divider';
import Column from 'src/components/10-atoms/layout/Column';
import Grid from 'src/components/10-atoms/layout/Grid';
import Typography from 'src/components/10-atoms/typography/Typography';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import QuestionPaperItem from './QuestionPaperItem';
const QuestionPaperGroupItem = ({ data, onQPPress, ...columnProps }) => {
    const [{ theme, dimensions, deviceType }] = useTheme(stylesGenerator);
    const cols = deviceType.isDesktop
        ? 4
        : dimensions.breakpoint.width.sm
            ? 2
            : 3;
    return (React.createElement(Column, { spacing: theme.spacing.standard.sm, ph: theme.spacing.page, ...columnProps },
        React.createElement(Typography, { variant: TypographyVariant.BODY_TITLE }, data.label),
        React.createElement(Divider, null),
        React.createElement(Grid, { cols: cols }, data.questionPapers.map(qp => (React.createElement(QuestionPaperItem, { key: qp.id, data: qp, to: {
                screen: 'EP_QP',
                params: { qpID: qp.id },
            }, ...(onQPPress ? { onPress: () => onQPPress(qp) } : {}) }))))));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    pageMargin: {
        marginHorizontal: theme.spacing.page,
    },
}));
export default QuestionPaperGroupItem;
